<template>
  <div>
    <section class="admin-section" aria-labelledby="admin-actions-heading">
      <CommonSettingsList/>
    </section>

  </div>

</template>

<script>
import CommonSettingsList from "./CommonSettingsList";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "CommonSettings",
  components: {
    CommonSettingsList,
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
    };
  },
  methods: {},
  watch: {},
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Ustawienia ogólne`)
  },
  created() {
    this.commonModule.httpGetLicensedFeatures();
    this.commonModule.httpGetWorkingProfile();
  },
};
</script>

<style scoped>


</style>
